<template>
  <b-badge
    class="sr-status-badge"
    :style="style"
    pill
  >
    {{ associated }}
  </b-badge>
</template>

<script>

export default {
    name: 'AssociatedCasesBadge',
    props: {
        associated: { type: Number, default: 0 }
    },
    computed: {
        style() {
            return { 'background-color': '#f5b372' }
        }
    }
}

</script>

<style scoped lang="scss">

.sr-status-badge {
  width: 25px;
}

</style>
